import React from 'react';
import WasteBreadcrumbs from '../shared/WasteBreadcrumbs';
import { SingleBreadcrumbItem } from 'framework/ui/BreadCrumbs';
import { useShowContext } from 'framework/show';
import { useWasteUrl } from 'domain/shared/waste';

const SingleWasteBreadcrumbsItem = ({ children }: { children?: React.ReactNode }) => {
  const { data } = useShowContext();
  const { getSingleEntityUrl } = useWasteUrl();
  const id = data?.getValueBySource('id');

  return (
    <WasteBreadcrumbs>
      <SingleBreadcrumbItem entity="Waste info" link={getSingleEntityUrl(id)} />
      {children}
    </WasteBreadcrumbs>
  );
};

export default SingleWasteBreadcrumbsItem;
